import request from '@/plugins/axios'

export function changePoints(id, value, remark) {
  // 增减积分
  return request({
    url: `authentication/users/${id}/points`,
    method: 'post',
    data: {
      points_value: value,
      remark
    }
  })
}

export function getPointsMenu(params) {
  // 管理员获取用户积分详情
  return request({
    url: '/service/points_historys',
    method: 'get',
    params
  })
}

export function getUserPoints(pageIndex, pageSize) {
  // 获取用户自己积分详情
  return request({
    url: '/user/me/pointsHistory',
    method: 'get',
    params: {
      pageIndex,
      pageSize
    }
  })
}
